import { Log } from 'probe.gl';
export default new Log({
  id: 'luma'
}).enable();
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/luma.gl/dist/esm/utils/log.js
// module id = 73
// module chunks = 0